<template>
  <div class="page">
    <wk-search
      class="wrapBox"
      :search-control-data="searchControlData"
      @search="search($event)"
    ></wk-search>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div style="line-height: 40px">共{{total}}条数据</div>
        <div>
          <el-button v-auth="permission.IMPORT_TASK_CREATE" class="common-button" type="primary" @click="createTask()">
            创建任务
          </el-button>
          <el-button v-auth="permission.IMPORT_TASK_TEMPLATE_DOWNLOAD" class="common-button" @click="downloadTemplate()">
            导入模板下载
          </el-button>
        </div>
      </div>
      <el-table
        v-auth="permission.IMPORT_TASK_LIST"
        class="tableBox"
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="任务创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="endTime"
          label="任务完成时间">
          <template slot-scope="scope">
            <span v-if="scope.row.endTime">{{ scope.row.endTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          label="任务状态">
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.state) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="totalCount"
          label="任务数量">
        </el-table-column>
        <el-table-column
          align="center"
          prop="successCount"
          label="成功数量">
        </el-table-column>
        <el-table-column
          align="center"
          prop="failCount"
          label="失败数量">
        </el-table-column>
        <el-table-column
          align="center"
          prop="adminName"
          label="操作员">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button v-auth="permission.IMPORT_TASK_VIEW" class="color-blue link-button" type="text" @click="view(scope.row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50]"
          :page-size="searchFormData.perPage"
          :current-page="searchFormData.page"
          layout="total, prev, pager, next, sizes"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <dataSetStatus ref="dataSetStatus"></dataSetStatus>
    <createTask ref="createTask" @update="search()"></createTask>
  </div>
</template>
<script>
  import store from '@/store/index.js';
  import dataSetStatus from './dialogs/dataSetStatus.vue';
  import createTask from './dialogs/createTask.vue';
  export default {
    components: {dataSetStatus, createTask},
    beforeRouteEnter: (to,from,next) => {
      store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name: "批量修改金标有效期", path: to.fullPath} );
      next()
    },
    data() {
      return {
        total: 0,
        loading: false,
        searchFormData: {
          page: 1,
          perPage: 10,
        },
        searchControlData: [
          {
            type: 'select',
            label: '任务状态',
            placeholder: '请选择',
            key: 'state',
            option: [
              {
                label: '全部',
                value: ''
              },
              {
                label: '待开始',
                value: '1'
              },
              {
                label: '进行中',
                value: '2'
              },
              {
                label: '已完成',
                value: '3'
              },
              {
                label: '失败',
                value: '4'
              },
            ]
          },
          {
            type: 'input',
            label: '操作员',
            placeholder: '请输入操作员',
            key: 'adminName'
          },
          {
            type: 'rangDate',
            label: '任务创建时间',
            key: 'createTime'
          },
        ],
        tableData: []
      }
    },
    created() {
      this.search()
    },
    methods: {
      search(data) {
        this.loading = true
        if (data) {
          Object.assign(this.searchFormData, data)
          // 任务创建时间范围（毫秒）
          this.searchFormData.startTime = data.createTime ? data.createTime[0] : ''
          this.searchFormData.endTime = data.createTime ? data.createTime[1] : ''
          delete this.searchFormData.createTime
          this.searchFormData.page = 1
        }
        // 清理空查询条件
        for (let key in this.searchFormData) {
          if (key != 'page' && key != 'perPage' && (this.searchFormData[key] === '' || this.searchFormData[key] === null || this.searchFormData[key] === undefined)) {
            delete this.searchFormData[key]
          }
        }
        this.$apis.importTaskServer.queryList(this.searchFormData).then(res => {
          if (res['code'] == 0 && res.data.data) {
            this.total = res.data.total
            this.tableData = res.data.data
          } else {
            this.total = 0
            this.tableData = []
          }
          this.loading = false
        })
      },
      // 转换状态
      getStatus(data) {
        switch (data) {
          case 1:
            return '待开始'
          case 2:
            return '进行中'
          case 3:
            return '已完成'
          case 4:
            return '失败'
          default:
            return '-'
        }
      },
      // 查看
      view(row) {
        this.$refs["dataSetStatus"].show(row);
      },
      // 创建任务
      createTask() {
        // 拉起文件上传器
        this.$refs["createTask"].open();
      },
      // 导入模板下载
      downloadTemplate() {
        const link = document.createElement('a')
        link.href = '/files/批量修改金标有效期导入模板.xls'
        link.download = '批量修改金标有效期导入模板.xls'
        link.click()
      },
      handleSizeChange(val) {
        this.searchFormData.perPage = val
        this.search()
      },
      handleCurrentChange(val) {
        this.searchFormData.page = val
        this.search()
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
